import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ql-live-stream__modal"
}
const _hoisted_2 = { class: "ql-live-stream__modal-body bs-container" }

import { nextTick, onBeforeUnmount, onMounted, reactive, ref, watch } from "vue";
import { isLiveStreamOpen, useLotteryStream } from "./use-ql-live-stream";
import { useStackedModals } from "@sazka/utils/composables/use-stacked-modals";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { debounce } from "@sazka/utils/debounce";

const closeButtonPositionOffset = 16;

export default /*@__PURE__*/_defineComponent({
  __name: '_ql-live-stream',
  setup(__props) {

const { addToStackedModals, removeFromStackedModals } = useStackedModals();
const streamContainerRef = ref<HTMLElement>(null);

const closeButtonRef = ref<InstanceType<typeof DsButton>>(null);
const closeButtonPositionClass = reactive({
    top: true,
    left: false,
    inside: false,
});

const setCloseButtonPosition = () => {
    if (!isLiveStreamOpen.value) return;
    const streamContainerRect = streamContainerRef.value.getBoundingClientRect();
    const closeButtonRect = closeButtonRef.value.rootElement.getBoundingClientRect();

    if (closeButtonRect.height <= streamContainerRect.y - closeButtonPositionOffset) {
        if (!closeButtonPositionClass.top) {
            closeButtonPositionClass.left = closeButtonPositionClass.inside = false;
            closeButtonPositionClass.top = true;
        }
    } else if (closeButtonRect.width <= window.innerWidth - streamContainerRect.right - closeButtonPositionOffset) {
        if (!closeButtonPositionClass.left) {
            closeButtonPositionClass.top = closeButtonPositionClass.inside = false;
            closeButtonPositionClass.left = true;
        }
    } else if (!closeButtonPositionClass.inside) {
        closeButtonPositionClass.top = closeButtonPositionClass.left = false;
        closeButtonPositionClass.inside = true;
    }
};

const resizeEventHandlerDebounced = debounce(setCloseButtonPosition, 50);
onMounted(() => {
    window.addEventListener("resize", resizeEventHandlerDebounced);
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", resizeEventHandlerDebounced);
});

const closeStreamDialog = () => {
    isLiveStreamOpen.value = false;
};

const keyDownEventHandler = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
        closeStreamDialog();
    }
};

const stream = useLotteryStream(streamContainerRef);
watch(isLiveStreamOpen, (newIsLiveStreamOpen, oldIsLiveStreamOpen) => {
    if (newIsLiveStreamOpen && !oldIsLiveStreamOpen) {
        addToStackedModals();
        window.addEventListener("keydown", keyDownEventHandler);
        stream.start();

        nextTick(() => {
            setCloseButtonPosition();
        });
    } else if (!newIsLiveStreamOpen && oldIsLiveStreamOpen) {
        removeFromStackedModals();
        window.removeEventListener("keydown", keyDownEventHandler);
        stream.stop();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "ql-live-stream" }, {
      default: _withCtx(() => [
        (_unref(isLiveStreamOpen))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "ql-live-stream__modal-background",
                onClick: closeStreamDialog
              }),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(DsButton, {
                  type: "interaction",
                  theme: "dark",
                  class: _normalizeClass(["ql-live-stream__modal-close", closeButtonPositionClass]),
                  ref_key: "closeButtonRef",
                  ref: closeButtonRef,
                  "aria-label": "Zavřít",
                  "icon-left": "cross",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (closeStreamDialog()))
                }, null, 8, ["class"]),
                _createElementVNode("div", {
                  class: "ql-live-stream__stream",
                  ref_key: "streamContainerRef",
                  ref: streamContainerRef
                }, null, 512)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})